__turbopack_context__.v({
  "accordionSlideOverwrite": "events-module-scss-module__qzyuOa__accordionSlideOverwrite",
  "content": "events-module-scss-module__qzyuOa__content",
  "eventsPage": "events-module-scss-module__qzyuOa__eventsPage",
  "fadeIn": "events-module-scss-module__qzyuOa__fadeIn",
  "fadeOut": "events-module-scss-module__qzyuOa__fadeOut",
  "listMode": "events-module-scss-module__qzyuOa__listMode",
  "listSection": "events-module-scss-module__qzyuOa__listSection",
  "listWrapper": "events-module-scss-module__qzyuOa__listWrapper",
  "map": "events-module-scss-module__qzyuOa__map",
  "mapDesktop": "events-module-scss-module__qzyuOa__mapDesktop",
  "mapWrapper": "events-module-scss-module__qzyuOa__mapWrapper",
  "pagination": "events-module-scss-module__qzyuOa__pagination",
  "scaleIn": "events-module-scss-module__qzyuOa__scaleIn",
  "scaleOut": "events-module-scss-module__qzyuOa__scaleOut",
  "searchBarRow": "events-module-scss-module__qzyuOa__searchBarRow",
  "searchContainer": "events-module-scss-module__qzyuOa__searchContainer",
  "zoomIn": "events-module-scss-module__qzyuOa__zoomIn",
  "zoomOut": "events-module-scss-module__qzyuOa__zoomOut",
});
